import React from "react";
import { Button } from "@chakra-ui/react";
import styles from "./index.module.css";
import "./style.css";

export const AccentButton = (props: any) => {
  return (
    <Button
      {...props}
      className={`${styles.button} ${styles.accentButton}`}
      height="32px"
      borderRadius="6px"
    >
      {props.children}
    </Button>
  );
};

export default AccentButton;

